import request from './request'

const tagApi = {
  // 添加tag
  saveTag (data) {
    return request.post('/tags', data)
  },
  // 删除tag
  deleteTag (tagId) {
    return request.delete('/tags/' + tagId)
  },
  // tag列表
  listTag () {
    return request.get('/tags')
  },
}

export default tagApi
